<template>
  <aside class="border rounded-2xl p-5 h-max">
    <div class="flex items-center justify-between">
      <div class="text-sm text-gray-500">Товарів</div>
      <div class="font-medium">{{ totalQty }}</div>
    </div>
    <div class="flex items-center justify-between mt-2">
      <div class="text-sm text-gray-500">Сума</div>
      <div class="text-lg font-semibold">{{ formatPrice(totalSum) }}</div>
    </div>

    <button
      class="mt-4 w-full px-5 py-3 rounded-xl font-semibold bg-pink-200 text-black hover:bg-pink-200/80"
      @click="emit('checkout')"
    >
      Перейти до оформлення
    </button>
    <button
      class="mt-2 w-full px-5 py-2 rounded-xl border hover:bg-gray-50 text-sm"
      @click="emit('clear')"
    >
      Очистити кошик
    </button>
  </aside>
</template>

<script setup lang="ts">
import { formatPrice } from "~/utils/money";

/* CartSummary — підсумок кошика. Тотали рахує сторінка, тут лише вивід. */

defineProps<{ totalQty: number; totalSum: number }>();

const emit = defineEmits<{ checkout: []; clear: [] }>();
</script>
